<template>
  <div class="wrapper">
    <div class="container-fluid">
      <div class="loader d-flex justify-content-center mb-3 align-items-center">
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem;"
          label=""
          type="grow"
        >
        </b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirm-login',
};
</script>

<script>
import axios from 'axios';

export default {
  name: 'SSOConfirmLogin',
  data: () => ({
    loader: true,
  }),
  async created() {
    try {
      const token = this.$route.params.token;
      const ssoType = this.$route.params.ssoType;
      const resp = await axios.get(
        `${process.env.API_ROOT}/sso/user/${token}`,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'x-access-token': token,
          },
        },
      );
      if (resp.status === 200) {
        const user = resp.data;
        user.ssoType = ssoType;
        
        localStorage.setItem('_indecx', JSON.stringify(user));
        this.$store.state.user = resp.data;

        this.loading = false;

        if(resp.data.companyList && resp.data.companyList.length > 1){
        this.$router.push(`/list-companies/${user._id}`);

        } else {
         this.$router.push(`/dashboard/${user.companyId}`);
        }
        
      } else {
        this.makeToast('Erro', resp.data);
      }
      this.loader = false;
    } catch (error) {
      this.loader = false;
      this.msg = `${this.$t('ssoPage.noAuth')}: ${error.response.data.message}`;
    }
  },
  methods: {
    makeToast(message, title, append = false) {
      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: 'danger',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/variables.scss';
@import '@/themes/default/mixins.scss';

.content {
  display: flex;
  width: 100%;
  overflow: hidden;
  padding: 0;
  height: calc(100vh - 62px);
  @media screen and (max-width: 575px) {
    height: calc(100vh - 58.4px);
  }
}

.loader {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/sso/confirm-login.vue